import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    lastLogin:null,
    canFetchNotifProgram:false
}

export const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    setLastLogin: (state, action) => {
      state.lastLogin = action.payload;
    },
    setCanFetchNotifProgram: (state, action) => {
      state.canFetchNotifProgram = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setLastLogin, setCanFetchNotifProgram } = onboardingSlice.actions

export default onboardingSlice.reducer